import { gsap } from "gsap";
gsap.defaults({ ease: "none" });

export default () => {
    const nodeSelectors = {
        container: '[js-animation-mouse-line="container"]',
    }

    function init() {
        const svg = document.querySelector(nodeSelectors.container);
        const svgns = "http://www.w3.org/2000/svg";

        // ---- Config ----
        const FOLLOW_EASE = 0.5;   // follow smoothing (lower = smoother/slower)
        const TRAILS = 30;          // number of separate curved trails
        const POINTS_PER_TRAIL = 12; // resolution of each trail (more = smoother/ heavier)

        // ---- Pointer tracking ----
        const pointer = { x: innerWidth / 2, y: innerHeight / 2 };
        addEventListener("mousemove", (e) => {
            pointer.x = e.clientX;
            pointer.y = e.clientY;
        });

        // Each trail has a <path> and an array of points
        const trails = [];

        let leaderRef = pointer; // each new trail follows the head of the previous one
        for (let i = 0; i < TRAILS; i++) {
            const path = document.createElementNS(svgns, "path");
            // style per path (fade farther ones)
            const opacity = (TRAILS - i) / TRAILS;

            path.setAttribute("fill", "none");
            path.setAttribute("stroke", "#FF005F");
            path.setAttribute("stroke-width", "2");
            path.setAttribute("stroke-linecap", "round");
            path.setAttribute("stroke-linejoin", "round");
            path.setAttribute("opacity", String(opacity));
            svg.appendChild(path);

            // initialize trail points at the current leader position
            const points = Array.from({ length: POINTS_PER_TRAIL }, () => ({
                x: leaderRef.x,
                y: leaderRef.y
            }));

            trails.push({ path, points, leader: leaderRef });

            // the head of this trail becomes the leader for the next trail
            leaderRef = points[0];
        }

// Build a nice smooth quadratic path from a list of points
        function buildPathD(points) {
            let d = `M${points[0].x},${points[0].y}`;
            for (let j = 1; j < points.length - 2; j++) {
                const xc = (points[j].x + points[j + 1].x) / 2;
                const yc = (points[j].y + points[j + 1].y) / 2;
                d += ` Q${points[j].x},${points[j].y} ${xc},${yc}`;
            }
            // connect last two points
            const penult = points[points.length - 2];
            const last = points[points.length - 1];
            d += ` T${last.x},${last.y}`;
            return d;
        }

// Update everything each frame
        gsap.ticker.add(() => {
            for (let i = 0; i < trails.length; i++) {
                const { path, points, leader } = trails[i];

                // head follows its leader
                points[0].x += (leader.x - points[0].x) * FOLLOW_EASE;
                points[0].y += (leader.y - points[0].y) * FOLLOW_EASE;

                // each subsequent point eases toward the previous point
                for (let j = 1; j < points.length; j++) {
                    points[j].x += (points[j - 1].x - points[j].x) * FOLLOW_EASE;
                    points[j].y += (points[j - 1].y - points[j].y) * FOLLOW_EASE;
                }

                path.setAttribute("d", buildPathD(points));
            }
        });

// Handle resize so the pointer default stays reasonable
        addEventListener("resize", () => {
            if (pointer.x > innerWidth || pointer.y > innerHeight) {
                pointer.x = innerWidth / 2;
                pointer.y = innerHeight / 2;
            }
        });






    }

    return Object.freeze({
        init,
        nodeSelectors
    });
};
